import { Handle, Position } from '@xyflow/react'
import edgeLogo from '@/assets/hivemq_Edge_vert.png'
import controlPlaneLogo from '@/assets/control-panel.png'
import { Box, Flex, Text, IconButton, VStack } from '@chakra-ui/react'

const handleStyleLeft1 = { left: -4, top: '20%' }
const handleStyleLeft2 = { left: -4, top: '40%' }
const handleStyleLeft3 = { left: -4, top: '60%' }
const handleStyleLeft4 = { left: -4, top: '80%' }

function handleCCClick() {
  window.open(import.meta.env.VITE_EDGE_CC_ADDRESS, '_blank', 'noreferrer')
}

function EdgeNodeBi() {
  return (
    <Box
      bg="brand.solid"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.700"
      p={3}
      minW="200px"
      boxShadow="md"
    >
      {/* Left handles for protocols */}
      <Handle id="a" type="target" position={Position.Left} style={handleStyleLeft1} />
      <Handle id="b" type="target" position={Position.Left} style={handleStyleLeft2} />
      <Handle id="b" type="source" position={Position.Left} style={handleStyleLeft2} />
      <Handle id="c" type="target" position={Position.Left} style={handleStyleLeft3} />
      <Handle id="c2" type="target" position={Position.Left} style={handleStyleLeft4} />
      <Handle id="d" type="target" position={Position.Bottom} />
      <Handle id="e" type="source" position={Position.Bottom} />

      <Flex gap={3} align="stretch">
        {/* Left column - Protocols */}
        <VStack align="start" gap={0.5} flex="none">
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Modbus
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            S7
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            OPC-UA
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            AB
          </Text>
        </VStack>

        {/* Center column - Logo and Control Panel */}
        <VStack flex="1" gap={1}>
          <a href={import.meta.env.VITE_EDGE_CC_ADDRESS} target="_blank" rel="noreferrer">
            <img
              src={edgeLogo}
              alt="HiveMQ Edge"
              style={{ height: '50px', objectFit: 'contain' }}
            />
          </a>
          <IconButton
            aria-label="Open Control Center"
            size="xs"
            variant="ghost"
            onClick={handleCCClick}
            _hover={{ bg: 'whiteAlpha.400' }}
          >
            <img
              src={controlPlaneLogo}
              alt="Control Panel"
              style={{ height: '16px', width: '16px' }}
            />
          </IconButton>
        </VStack>

        {/* Right column - Features */}
        <VStack align="end" gap={0.5} flex="none">
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            MQTT
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            UNS
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Bridge
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Logs
          </Text>
        </VStack>
      </Flex>

      {/* Right handles */}
      <Handle type="source" position={Position.Right} id="right" />
      <Handle type="target" position={Position.Right} id="right" />
    </Box>
  )
}

export default EdgeNodeBi
